<div class="settings-layout">
  <h2>
    settings
  </h2>
  
  <div class="settings-layout-container">
    <div class="council-logo-container">
      <h3>council logo</h3>      
      <form (submit)="onSubmitCouncilLogo()">
          <div class="label info green flash" *ngIf="uploadStatus === 'added'" @flash>
            <p>image was saved.</p>
          </div>
          <div class="label info green flash" *ngIf="uploadStatus === 'deleted'" @flash>
            <p>image was deleted.</p>
          </div>
          <div class="label info red flash" *ngIf="uploadStatus === 'error'" @flash>
            <p>something went wrong, please try again.</p>
          </div>   
          <div class="container">
            <div class="image-box">
              <!-- This is the fixed-size box to display the image -->
              <img [src]="councilLogoImage" alt="Image" class="image-preview">
            </div>
            <div class="right-section">
              <div class="card">
                <div class="radio-group">
                  <label class="form-group">
                    <span class="select-layer">
                      <input type="radio" class="app-radio" name="council-logo" [(ngModel)]="councilLogoType" value="1" (change)="onCouncilLogoImageTypeChange()">
                      <span class="radio-text">Upload Image</span>
                    </span>
                  </label>
                  <label class="form-group">
                    <span class="select-layer">
                      <input type="radio" class="app-radio" name="council-logo" [(ngModel)]="councilLogoType" value="2" (change)="onCouncilLogoImageTypeChange()">
                      <span class="radio-text">Image URL</span>
                    </span>
                  </label>
                </div>
              </div>
              <div class="image-format-message-container">
                <div class="message" *ngIf="councilLogoType === '1'">
                  Images must be in a JPG or PNG format with a maximum size of 512KB.
                </div>  
              </div>
              <!-- Conditional HTML -->
              <div class="conditional-content">
                <div class="label info red" *ngIf="(councilLogoType === '1' && sizeFormatImageErrorLogo.length > 0)">
                  {{ sizeFormatImageErrorLogo }}
                </div>
                <div class="image-type-choice">
                  <input aria-label="" type="file" id="image-uploader" (change)="onSelectImageLogo($event)" *ngIf="councilLogoType === '1'">
                  <label for="image-uploader" class="app-submit" *ngIf="councilLogoType === '1'">
                    choose image
                  </label>
                  <label class="form-group" *ngIf="councilLogoType === '2'">
                  <span class="input-layer">
                    <input aria-label="" class="app-input" name="image-url" placeholder="https://example.com/image.jpg"
                          type="text" [(ngModel)]="imageUrlLogo" (blur)="onCouncilImageUrlBlur()">
                  </span>
                </label>
                </div>
                <label class="form-group">
                  <input aria-label="" class="app-submit" type="submit" value="Save" [disabled]="!isSubmitEnableLogo()">
                </label>
              </div>          
            </div>
          </div>
        </form>      
    </div>
      
    <div class="signatures-container">
      <form (submit)="onSubmitSignature()">
        <h3>add signature</h3>
        <div class="container">
          <div class="image-box">
            <img [src]="signatureImage" alt="Image" class="image-preview">
          </div>
          <div class="right-section">
            <div class="card">
              <div class="radio-group">
                <label class="form-group">
                  <span class="select-layer">
                    <input type="radio" class="app-radio" name="signature-image" [(ngModel)]="signatureImageType" value="1" (change)="onSignatureImageTypeChange()">
                    <span class="radio-text">Upload Image</span>
                  </span>
                </label>
                <label class="form-group">
                  <span class="select-layer">
                    <input type="radio" class="app-radio" name="signature-image" [(ngModel)]="signatureImageType" value="2" (change)="onSignatureImageTypeChange()">
                    <span class="radio-text">Image URL</span>
                  </span>
                </label>
              </div>
            </div>
            <div class="image-format-message-container">
              <div class="message" *ngIf="signatureImageType === '1'">
                Images must be in a JPG or PNG format with a maximum size of 512KB.
              </div>  
            </div>
            <!-- Conditional HTML -->
            <div class="conditional-content">
              <div class="label info red" *ngIf="(signatureImageType === '1' && sizeFormatImageErrorLogo.length > 0)">
                {{ sizeFormatImageErrorLogo }}
              </div>
              <div class="image-type-choice">
                <input aria-label="" type="file" id="image-uploader-signature" (change)="onSelectImageSignature($event)" *ngIf="signatureImageType === '1'">
                <label for="image-uploader-signature" class="app-submit" *ngIf="signatureImageType === '1'">
                  choose image
                </label>
                <label class="form-group" *ngIf="signatureImageType === '2'">
                <span class="input-layer">
                  <input aria-label="" class="app-input" name="image-url" placeholder="https://example.com/image.jpg"
                        type="text" [(ngModel)]="imageUrlSignature" (blur)="onSignatureImageUrlBlur()">
                </span>
              </label>
              </div>
              <label class="form-group">
                <input aria-label="" class="app-submit" type="submit" value="Save" [disabled]="!isSubmitEnableSignature()">
              </label>
            </div>          
          </div>
        </div>
      </form> 

      <h3>signature images</h3>
        <table class="table-list box-shadow signatures">
          <!-- <thead>
            <tr>
              <td style="width: 80%;">
                <span>image</span>
              </td>
              <td>
                <span>action</span>
              </td>
            </tr>
          </thead> -->
          <tbody>
            <tr *ngFor="let signature of signatures" 
            class="signature"
            (click)="onSignatureSelected(signature)">
              <td>
                <img [src]="signature.image" *ngIf="signature.tooltip !== null && signature.tooltip !== ''"
                    [ngbPopover]="signature.tooltip" triggers="hover" placement="right"/>
                <img [src]="signature.image" *ngIf="signature.tooltip === null || signature.tooltip === ''" />
              </td>
              <td>
                <button class="btn btn-delete btn-sm" (click)="deleteSignature(signature.id)">
                  <i class="fa fa-trash"></i> Delete
                </button>                
              </td>
            </tr>
          </tbody>
        </table>

           
    </div>
  </div>

  <div class="spinner-section-container">
    <h3>loading spinner</h3>
    <form (submit)="onSubmitSpinnerStyle()">
      <p class="message">Choose your favourite spinner below, then save your choice.</p>
      <div class="spinner-grid">
        <div
          class="spinner-card"
          *ngFor="let variant of spinnerVariants"
          [class.selected]="selectedSpinnerStyle === variant"
          (click)="onSelectSpinnerStyle(variant)"
        >
          <div class="rm-spinner {{ variant }}"></div>
        </div>
      </div>
      <div class="spinner-save-row">
        <label class="form-group">
          <input aria-label="" class="app-submit" type="submit" value="Save" [disabled]="!isSubmitEnableSpinnerStyle()">
        </label>
        <span class="inline-status success" *ngIf="spinnerSaveStatus === 'added'">spinner selection saved</span>
        <span class="inline-status error" *ngIf="spinnerSaveStatus === 'error'">something went wrong, please try again.</span>
      </div>
    </form>
  </div>

</div>
